import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/commom/pic_success1.svg';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4b69933d"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "callbackPupop"
};
var _hoisted_2 = {
  "class": "header"
};
var _hoisted_3 = {
  "class": "content"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "success",
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_5 = {
  "class": "text"
};
var _hoisted_6 = {
  "class": "bing-box"
};
var _hoisted_7 = {
  key: 0,
  "class": "text1"
};
var _hoisted_8 = {
  key: 1
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  key: 2,
  "class": "text1"
};
var _hoisted_11 = {
  key: 3,
  "class": "text1"
};
var _hoisted_12 = {
  "class": "flex-start"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = ["src"];
var _hoisted_15 = ["src"];
var _hoisted_16 = {
  "class": "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");
  var _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: _ctx.showBindingBox,
    "onUpdate:show": _cache[7] || (_cache[7] = function ($event) {
      return _ctx.showBindingBox = $event;
    }),
    style: _normalizeStyle($options.isMobile ? '' : {
      width: '22.8rem'
    }),
    position: "center",
    round: $options.isMobile ? true : false,
    "lazy-render": false,
    "class": "dialog-pop-box",
    onClickCloseIcon: $options.handleClosesBox,
    onClickOverlay: $options.handleClosesBox
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("i", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $options.handleClosesBox();
        }),
        "class": "close"
      })]), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('publish.successful')), 1)]), _createElementVNode("div", _hoisted_6, [!$data.userInfo.email ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('mailboxBinding.tip1')), 1)) : _createCommentVNode("", true), !$data.userInfo.email ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return $options.handleClosesBox(3);
        }),
        "class": "btn-box"
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("img", {
            "class": "icon3",
            style: {
              "margin-left": "0"
            },
            src: require('@/assets/image/mailboxBinding/icon3.png'),
            alt: ""
          }, null, 8, _hoisted_9), _createTextVNode(" " + _toDisplayString(_ctx.$t('mailboxBinding.tip6')), 1)];
        }),
        _: 1
      })])) : _createCommentVNode("", true), !$data.userInfo.email ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('mailboxBinding.tip2')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('mailboxBinding.tip5')), 1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
        "class": "icon-btn icon1",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.$toUrl('https://twitter.com/OpenNameProject');
        }),
        src: require('@/assets/image/mailboxBinding/icon2.png'),
        alt: ""
      }, null, 8, _hoisted_13), _createElementVNode("img", {
        "class": "icon-btn icon3",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.$toUrl('https://t.me/opennameproject');
        }),
        src: require('@/assets/image/mailboxBinding/icon4.png'),
        alt: ""
      }, null, 8, _hoisted_14), _createElementVNode("img", {
        "class": "icon-btn icon2",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return _ctx.$toUrl('https://discord.com/invite/G83NXk7YHp');
        }),
        src: require('@/assets/image/mailboxBinding/icon1.png'),
        alt: ""
      }, null, 8, _hoisted_15)])]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_button, {
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return $options.handleClosesBox(1);
        }),
        "class": "set-btn"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('mailboxBinding.tip3')), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        color: "#000",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return $options.handleClosesBox(2);
        })
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('mailboxBinding.tip4')), 1)];
        }),
        _: 1
      })])];
    }),
    _: 1
  }, 8, ["show", "style", "round", "onClickCloseIcon", "onClickOverlay"])]);
}